import Tables from 'src/class/Tables';
import i18n from "../../../../../i18n";

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'date_save',
      label: i18n.t('common_words.save_date'),
      minWidth: 170,
      sortable: true,
      align: 'center',
      fixed: true,
    },
    {
      prop: 'farm_name',
      label: i18n.t('common_words.farm'),
      minWidth: 170,
      fixed: true,
    },
    {
      prop: 'lot_name',
      label: i18n.t('common_words.allotment'),
      minWidth: 100,
      sortable: true,
      align: 'center',
      fixed: true,
    },
    {
      prop: 'user_name',
      label: i18n.t('common_words.user'),
      minWidth: 170,
      sortable: true,
    },
    {
      prop: 'week_save',
      label: i18n.t('common_words.week'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'day_save',
      label: i18n.t('common_words.day'),
      minWidth: 120,
    },
    {
      prop: 'observation',
      label: i18n.t('common_words.observation'),
      minWidth: 250,
    },
  ];

  return {Table};
};

export default configTable;
